export enum LogGroup {
    EDITOR = "editor",
    UNDO = "undo",
    CANVAS = "canvas",
    COLLABORATION = "collaboration",
    LAYOUT = "layout",
    ASSETS = "assets",
    THUMBNAIL = "thumbnail",
    LOGO = "logo",
    PLAYER = "player",
    PRESENTATION = "presentation",
    SLIDE = "slide",
    USER = "user",
    ADAPTER = "adapter",
    ANIMATION = "animation",
    SELECTION = "selection",
    TASK = "task",
    AUTH = "auth",
    AUTHORING = "authoring",
    MIGRATION = "migration",
    MONGO_MIGRATION = "mongoMigration",
    SPELLCHECK = "spellcheck",
    NOTIFICATION = "notification",
    AUDIT = "audit",
    ANALYTICS = "analytics",
    EXPORT = "export",
    DATA_SERVICE = "dataService",
    CONVERT_TO_AUTHORING = "convertToAuthoring",
    OBSERVABLES = "observables",
    COMMENTS = "comments",
    PUSHER = "pusher",
    EXPORT_CACHE = "exportCache",
    DATA_SOURCE = "dataSource",
    DEFAULT = "default",
    WINDOW = "window",
    APP = "app",
    ELEMENTS = "elements",
    BILLING = "billing",
    INVITES = "invites",
    TEAMS = "teams",
    PERMISSIONS = "permissions",
    AUDIO = "audio",
    FONTS = "fonts",
    FEATURES = "features",
    STORAGE = "storage",
    PPT_IMPORT = "pptImport",
    THEMES = "themes",
    PPT_ADDIN = "pptAddin",
    ENTRYPOINT = "entrypoint",
    API = "api",
    RENDERER = "renderer",
    CANVAS_LAYOUTER = "canvasLayouter",
    CLIPBOARD = "clipboard",
    GDRIVE = "gDrive",
    LOCAL_STORAGE = "localStorage",
    HELP_MENU = "helpMenu",
    AI = "ai",
    LINKS = "links",
    SSO = "sso"
}

export enum LogLevel {
    INFO = "INFO",
    WARNING = "WARNING",
    ERROR = "ERROR"
}
